module.exports = __webpack_public_path__ + "static/media/postgresql.1e83f710.svg";